import { render } from "./achivementDisplay.vue?vue&type=template&id=3a967bc6&scoped=true"
import script from "./achivementDisplay.vue?vue&type=script&lang=js"
export * from "./achivementDisplay.vue?vue&type=script&lang=js"

import "./achivementDisplay.vue?vue&type=style&index=0&id=3a967bc6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a967bc6"]])

export default __exports__